import { RepresentantDashboard } from 'NewVersion/components/Proposal/RepresentantDashboard'
import 'NewVersion/styles/ProposalsStyles.scss'

/**
 * RepresentantDashboardPage - Page wrapper for the Representant Dashboard
 */
const RepresentantDashboardPage = () => {
  return (
    <section className="proposals page-wrapper">
      <RepresentantDashboard />
    </section>
  )
}

export default RepresentantDashboardPage
